import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'
/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
}
const routerReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(error => error)
}
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['@/components/home.vue'], resolve),
    },
    {
      path: '/forgot_password',
      component: resolve => require(['@/components/forgot_password.vue'], resolve),
      meta: {
        title: '忘记密码'
      },
    },
    {
      path: '/business_cooperation',
      component: resolve => require(['@/components/business_cooperation.vue'], resolve),
      meta: {
        title: '商务合作'
      },
    },
    {
      path: '/about_us',
      component: resolve => require(['@/components/about_us.vue'], resolve),
      meta: {
        title: '关于我们'
      },
    },
    {
      path: '/concat_us',
      component: resolve => require(['@/components/concat_us.vue'], resolve),
      meta: {
        title: '联系我们'
      },
    },
    {
      path: '/login',
      component: resolve => require(['@/components/login.vue'], resolve),
      meta: {
        title: '登录注册'
      },
    },
    {
      path: '/alipay_return',
      component: resolve => require(['@/components/alipay_return.vue'], resolve),
      meta: {
        title: '支付跳转'
      },
    },
    {
      path: '/hotel_list',
      component: resolve => require(['@/components/hotel_list.vue'], resolve),
      meta: {
        title: '酒店列表',
        requireAuth: true
      },
    },
    {
      path: '/hotel_detail',
      component: resolve => require(['@/components/hotel_detail.vue'], resolve),
      meta: {
        title: '酒店详情',
        requireAuth: true
      },
    },
    {
      path: '/order_detail',
      component: resolve => require(['@/components/order_detail.vue'], resolve),
      meta: {
        title: '订单详情',
        requireAuth: true
      },
    },
    {
      path: '/booking',
      redirect: '/booking/make_order',
      component: resolve => require(['@/components/booking/booking_hotel.vue'], resolve),
      children: [
        {
          path: 'make_order',
          component: resolve => require(['@/components/booking/make_order.vue'], resolve),
          meta: {
            title: '酒店预订',
          },
        },
        {
          path: 'make_status',
          component: resolve => require(['@/components/booking/make_status.vue'], resolve),
          meta: {
            title: '状态展示'
          },
        },
      ],
      meta: {
        title: '酒店预订',
        requireAuth: true
      },
    },
    {
      path: '/user',
      redirect: '/user/user_info',
      component: resolve => require(['@/components/user/user_center.vue'], resolve),
      children: [
        {
          path: 'user_info',
          component: resolve => require(['@/components/user/user_info.vue'], resolve),
          meta: {
            title: '个人资料',
            requireAuth: true
          },
        },
        {
          path: 'vcc_index',
          component: resolve => require(['@/components/user/vcc_index.vue'], resolve),
          meta: {
            title: '虚拟卡',
            requireAuth: true
          },
        },
        {
          path: 'vcc_info',
          component: resolve => require(['@/components/user/vcc_info.vue'], resolve),
          meta: {
            title: '虚拟卡',
            requireAuth: true
          },
        },
        {
          path: 'add_vcc',
          component: resolve => require(['@/components/user/add_vcc.vue'], resolve),
          meta: {
            title: '新建虚拟卡',
            requireAuth: true
          },
        },
        {
          path: 'agent_info',
          component: resolve => require(['@/components/user/agent_info.vue'], resolve),
          meta: {
            title: '代理人信息',
            requireAuth: true
          },
        },
        {
          path: 'edit_user',
          component: resolve => require(['@/components/user/edit_user.vue'], resolve),
          meta: {
            title: '修改资料',
            requireAuth: true
          },
        },
        {
          path: 'invoice_apply',
          component: resolve => require(['@/components/user/invoice_apply.vue'], resolve),
          meta: {
            title: '发票申请',
            keepAlive: true,
            requireAuth: true
          },
        },
        {
          path: 'invoice_submit',
          component: resolve => require(['@/components/user/invoice_submit.vue'], resolve),
          meta: {
            title: '提交发票申请',
            requireAuth: true
          },
        },
        {
          path: 'invoice_list',
          component: resolve => require(['@/components/user/invoice_list.vue'], resolve),
          meta: {
            title: '开票历史',
            requireAuth: true
          },
        },
        {
          path: 'change_password',
          component: resolve => require(['@/components/user/change_password.vue'], resolve),
          meta: {
            title: '修改密码'
          },
        },
        {
          path: 'add_agent',
          component: resolve => require(['@/components/user/add_agent.vue'], resolve),
          meta: {
            title: '新增代理'
          },
        },
        {
          path: 'user_order',
          component: resolve => require(['@/components/user/user_order.vue'], resolve),
          meta: {
            title: '我的订单',
            requireAuth: true
          },
        },
        {
          path: 'user_collection',
          component: resolve => require(['@/components/user/user_collection.vue'], resolve),
          meta: {
            title: '我的收藏',
            requireAuth: true
          },
        },
        {
          path: 'user_account',
          component: resolve => require(['@/components/user/user_account.vue'], resolve),
          meta: {
            title: '我的收益',
            requireAuth: true
          },
        },
        {
          path: 'user_agent',
          component: resolve => require(['@/components/user/user_agent.vue'], resolve),
          meta: {
            title: '我的代理',
            requireAuth: true
          },
        },
        {
          path: 'apply_cash',
          component: resolve => require(['@/components/user/apply_cash.vue'], resolve),
          meta: {
            title: '申请提现',
            requireAuth: true
          },
        },
        {
          path: 'cash_list',
          component: resolve => require(['@/components/user/cash_list.vue'], resolve),
          meta: {
            title: '提现历史',
            requireAuth: true
          },
        },
        {
          path: 'notifies',
          component: resolve => require(['@/components/user/user_notifies.vue'], resolve),
          meta: {
            title: '站内消息',
            requireAuth: true
          },
        }
      ],
      meta: {
        title: '会员中心'
      },
    },
  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  if (from.meta.title != to.meta.title) {
    window.scrollTo(0, 0);
  }

  if (to.meta.requireAuth) {
    // store.state.userInfo sessionStorage.getItem("a_user")
    if (store.state.userInfo) {
      next();
    } else {
      next({ path: '/login' })
    }
  } else {
    next();
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js